import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { setAxiosAuth } from 'utils';
import { getBookingInfo } from 'core/api/booking/booking.api';
import { UseGetBookingInfoProps } from './types';

export const useGetBookingInfo = ({
  confirmId,
  accessToken = ''
}: UseGetBookingInfoProps) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.bookingInfo, confirmId],
    queryFn: async () => await getBookingInfo(confirmId),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken && confirmId),
    refetchOnWindowFocus: 'always',
  });
}
